import { TBioResponse } from "@store/reducers";

export default class SaveBiometryResultRequest {
  private numeroCarteiraBeneficiario: string;
  private cnpjPrestador: string;
  private codigoMotivoAusenciaBiometria: string;
  private descricaoMotivoAusenciaBiometria: string;
  private mensagem: string;
  constructor(
    numeroCarteiraBeneficiario: string,
    cnpjPrestador: string,
    mensagem: string,
    status: TBioResponse
  ) {
    this.numeroCarteiraBeneficiario = numeroCarteiraBeneficiario;
    this.cnpjPrestador = cnpjPrestador;
    this.mensagem = mensagem;
    this.codigoMotivoAusenciaBiometria = "";
    this.descricaoMotivoAusenciaBiometria = "";
    if (status != 200 && status != 400) {
      this.codigoMotivoAusenciaBiometria = status.toString();
      this.descricaoMotivoAusenciaBiometria =
        this.getDescriptionMissingBiometry(status);
    }
  }
  private getDescriptionMissingBiometry = (status: TBioResponse) => {
    switch (status) {
      case 201:
        return "Face cadastrada";
      case 202:
        return "Verificacao Justificada";
      case 203:
      default:
        return "Cadastro sem captura de foto";
    }
  };
}
